import * as Sentry from '@sentry/vue';

/**
 * logMessage logs the message to Sentry for informational/debugging purposes
 *
 * @param {string} msg
 */
export function logMessage(msg) {
  if (!msg) {
    return;
  }
  Sentry.captureMessage(msg);
}

/**
 * logError logs the error to Sentry and includes the stack trace
 *
 * @param {Error} err - the Error object
 */
export function logError(err) {
  if (!err) {
    return;
  }
  Sentry.captureException(err);
}
